// Employment type for job postings / employees (per Mudassir's Jun-16 hiring
// baseline handoff). Replaces the old free-text "employementType" field.
export const EmploymentTypeEnum = Object.freeze({
  FullTime: 0,
  Internship: 1,
  Contractor: 2,
  Consultant: 3,
});

export const EmploymentTypeEnumLabel = Object.freeze({
  [EmploymentTypeEnum.FullTime]: "Full-time",
  [EmploymentTypeEnum.Internship]: "Internship",
  [EmploymentTypeEnum.Contractor]: "Contractor",
  [EmploymentTypeEnum.Consultant]: "Consultant",
});

// Options for an AntD / select dropdown.
export const EmploymentTypeOptions = Object.entries(EmploymentTypeEnumLabel).map(
  ([value, label]) => ({ value: Number(value), label })
);
